import { render, staticRenderFns } from "./DashboardIcon.vue?vue&type=template&id=ce69296a&scoped=true&"
import script from "./DashboardIcon.vue?vue&type=script&lang=js&"
export * from "./DashboardIcon.vue?vue&type=script&lang=js&"
import style0 from "./DashboardIcon.vue?vue&type=style&index=0&id=ce69296a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce69296a",
  null
  
)

export default component.exports